var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexchart',{attrs:{"width":"100%","height":"300px","type":_vm.options.chart.type,"options":_vm.options,"series":_vm.options.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }